export default __webpack_public_path__ + "static/fundamental2-403d8bdf0b00fd9a799d4dc38d76eea6.png";